<div class="deductions-info__wrap top">
  <div class="deductions-info__toltip-wrap alert_wrap">
    <img src="../../../../../../assets/svg/warning-icon.svg" class="alert_icon">
  </div>
  <div class="deductions-info__wrap-text">
    <p class="deductions-info__text">
      {{ text | translate }}
    </p>
    <p class="deductions-info__text bolded">
      {{ hardText | translate }}
    </p>
  </div>
</div>